import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import {
  AppstoreOutlined,
  FileTextOutlined,
  FlagOutlined,
  // LikeOutlined,
  ProfileOutlined,
  // MedicineBoxOutlined,
  ReconciliationOutlined,
  ScheduleOutlined,
  StarOutlined,
  UserAddOutlined,
  UsergroupDeleteOutlined,
  MessageOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import useUser from "../hooks/useUser";
import { Tooltip } from "antd";
// import { useUnreadMessages } from "./context/unreadMessagesProvider";
import { useUnreadMessages } from "./context/UnreadMessagesProvider";
import { socket } from "../utils/socket";
// import { menuicon10 } from "./imagepath";
// import { Chat } from "@mui/icons-material";

const Sidebar = () => {
  const {
    isSuperAdmin,
    isRadiologist,
    isSitePerson,
    isSubAdmin,
    isQualityChecker,
  } = useUser();
  const location = useLocation();
  const { pathname } = location;
  const [isMiniSidebar, setIsMiniSidebar] = useState(false);
  const { unreadCount, setUnreadCount } = useUnreadMessages();
  // Check for the 'mini-sidebar' class on the body element
  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     setIsMiniSidebar(document.body.classList.contains("mini-sidebar"));
  //   }, 100); // Runs every 1000 milliseconds (1 second)

  //   // Cleanup the interval when the component unmounts
  //   return () => clearInterval(intervalId);
  // }, []);

  const getActiveClassName = (path) => (pathname === path ? "active" : "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsMiniSidebar(document.body.classList.contains("mini-sidebar"));
    });

    // Start observing changes to the body's class attribute
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // Initial check
    setIsMiniSidebar(document.body.classList.contains("mini-sidebar"));

    // Clean up the observer when the component unmounts
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    document.body.classList.add("mini-sidebar");
  }, []);
  useEffect(() => {
    const recieveMessage = async () => {
      try {
        setUnreadCount((prev) => parseInt(prev) + 1);
      } catch (error) {
        console.log("Error-->", error);
      }
    };
    socket.on("receive-message", recieveMessage);
    return () => {
      socket.off("receive-message", recieveMessage);
    };
  }, [socket]);
  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };

  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  // console.log("unread count-->", unreadCount);
  const manageClassName = () => {
    if (window.innerWidth <= 580) {
      document.getElementsByTagName("html")[0].classList.remove("menu-opened");
      document.body.classList.remove("slide-nav");
      document
        .getElementsByClassName("sidebar-overlay")[0]
        .classList.remove("opened");
    }
  };
  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="85vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu"
              onMouseLeave={expandMenu}
              onMouseOver={expandMenuOpen}
            >
              <ul>
                <li className="menu-title">Records</li>
                {(isSuperAdmin ||
                  isRadiologist ||
                  isSitePerson ||
                  isQualityChecker ||
                  isSubAdmin) && (
                  <>
                    <Tooltip
                      placement="right"
                      title={isMiniSidebar && "Studies"}
                    >
                      <li>
                        <Link
                          to="/studies"
                          className={getActiveClassName("/studies")}
                          onClick={manageClassName}
                        >
                          <span className="menu-side">
                            <ReconciliationOutlined />
                          </span>{" "}
                          <span className="child_studie">Studies</span>
                        </Link>
                      </li>
                    </Tooltip>
                  </>
                )}

                <Tooltip placement="right" title={isMiniSidebar && "Chat"}>
                  <li>
                    <div className="chat-user-count sidebar_chat">
                      {unreadCount > 0 && <span>{unreadCount}</span>}
                    </div>
                    <Link
                      className={getActiveClassName("/chat")}
                      to={"/chat"}
                      onClick={manageClassName}
                    >
                      <span className="menu-side">
                        <MessageOutlined />
                      </span>{" "}
                      <span className="child_studie">Chat</span>
                    </Link>
                  </li>
                </Tooltip>
                {isSuperAdmin && (
                  <>
                    <li className="menu-title">User</li>
                    <Tooltip
                      placement="right"
                      title={isMiniSidebar && "Register User"}
                    >
                      <li>
                        <Link
                          to="/signup"
                          className={getActiveClassName("/signup")}
                          onClick={manageClassName}
                        >
                          <span className="menu-side">
                            <UserAddOutlined />
                          </span>{" "}
                          <span className="child_studie">Register User</span>
                        </Link>
                      </li>
                    </Tooltip>
                    <Tooltip
                      placement="right"
                      title={isMiniSidebar && "Manage Users"}
                    >
                      <li>
                        <Link
                          to="/manageusers"
                          className={getActiveClassName("/manageusers")}
                          onClick={manageClassName}
                        >
                          <span className="menu-side">
                            <UsergroupDeleteOutlined />
                          </span>{" "}
                          <span className="child_studie">Manage Users</span>
                        </Link>
                      </li>
                    </Tooltip>
                  </>
                )}

                {(isSuperAdmin || isSubAdmin || isRadiologist) && (
                  <>
                    <li className="menu-title">Schedule</li>
                    <Tooltip
                      placement="right"
                      title={isMiniSidebar && "Radiologist Slots"}
                    >
                      <li>
                        <Link
                          to="/radiologistslots"
                          className={getActiveClassName("/radiologistslots")}
                          onClick={manageClassName}
                        >
                          <span className="menu-side">
                            <ScheduleOutlined />
                          </span>{" "}
                          <span className="child_studie">
                            {" "}
                            Radiologist Slots
                          </span>
                        </Link>
                      </li>
                    </Tooltip>
                  </>
                )}

                {(isSuperAdmin || isSubAdmin || isSitePerson) && (
                  <>
                    <li className="menu-title">Machine</li>
                    <Tooltip
                      placement="right"
                      title={isMiniSidebar && "Machine"}
                    >
                      <li>
                        <Link
                          to="/machine"
                          className={getActiveClassName("/machine")}
                          onClick={manageClassName}
                        >
                          <span className="menu-side">
                            <SettingOutlined />
                          </span>{" "}
                          <span className="child_studie"> Add Machine</span>
                        </Link>
                      </li>
                    </Tooltip>
                  </>
                )}
                {(isSuperAdmin || isSubAdmin || isRadiologist) && (
                  <>
                    <li className="menu-title">Masters</li>
                    {isSuperAdmin && (
                      <Tooltip
                        placement="right"
                        title={isMiniSidebar && "Manage Grades"}
                      >
                        <li>
                          <Link
                            to="/gradetable"
                            className={getActiveClassName("/gradetable")}
                            onClick={manageClassName}
                          >
                            <span className="menu-side">
                              <StarOutlined />
                            </span>{" "}
                            <span className="child_studie"> Manage Grades</span>
                          </Link>
                        </li>
                      </Tooltip>
                    )}
                    {(isSuperAdmin || isSubAdmin) && (
                      <Tooltip
                        placement="right"
                        title={isMiniSidebar && "Manage Priorities"}
                      >
                        <li>
                          <Link
                            to="/prioritytable"
                            className={getActiveClassName("/prioritytable")}
                            onClick={manageClassName}
                          >
                            <span className="menu-side">
                              <FlagOutlined />
                            </span>{" "}
                            <span className="child_studie">
                              {" "}
                              Manage Priorities
                            </span>
                          </Link>
                        </li>
                      </Tooltip>
                    )}
                    {/* <Tooltip
                      placement="right"
                      title={isMiniSidebar && "Manage Qualities"}
                    >
                      <li>
                        <Link
                          to="/qualitytable"
                          className={getActiveClassName("/qualitytable")}
                        >
                          <span className="menu-side">
                            <LikeOutlined />
                          </span>{" "}
                          <span className="child_studie">
                            {" "}
                            Manage Qualities
                          </span>
                        </Link>
                      </li>
                    </Tooltip> */}
                    {/* <li>
                      <Link
                        to="/centerstable"
                        className={getActiveClassName("/centerstable")}
                      >
                        <span className="menu-side">
                          <MedicineBoxOutlined />
                        </span>{" "}
                        <span className="child_studie"> Manage Centers</span>
                      </Link>
                    </li> */}
                    <Tooltip
                      placement="right"
                      title={isMiniSidebar && "Manage Templates"}
                    >
                      <li>
                        <Link
                          to="/templates"
                          className={getActiveClassName("/templates")}
                          onClick={manageClassName}
                        >
                          <span className="menu-side">
                            <FileTextOutlined />
                          </span>{" "}
                          <span className="child_studie">
                            {" "}
                            Manage Templates
                          </span>
                        </Link>
                      </li>
                    </Tooltip>
                    {isSuperAdmin && (
                      <Tooltip
                        placement="right"
                        title={isMiniSidebar && "Manage Categories"}
                      >
                        <li>
                          <Link
                            to="/categories"
                            className={getActiveClassName("/categories")}
                            onClick={manageClassName}
                          >
                            <span className="menu-side">
                              <AppstoreOutlined />
                            </span>{" "}
                            <span className="child_studie">
                              {" "}
                              Manage Categories
                            </span>
                          </Link>
                        </li>
                      </Tooltip>
                    )}
                    {(isSuperAdmin || isSubAdmin) && (
                      <Tooltip
                        placement="right"
                        title={isMiniSidebar && "Digital Sharing"}
                      >
                        <li>
                          <Link
                            to="/reports"
                            className={getActiveClassName("/reports")}
                            onClick={manageClassName}
                          >
                            <span className="menu-side">
                              <ProfileOutlined />
                            </span>{" "}
                            <span className="child_studie">
                              {" "}
                              Digital Sharing
                            </span>
                          </Link>
                        </li>
                      </Tooltip>
                    )}
                  </>
                )}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
